/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {AbstractHttpService} from '@/services/http/abstract';

/**
 * Http factory.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export class HttpFactory {
    /**
     * Instance creator (using generics)
     *
     * @param {{new(): T}} c
     *
     * @return {T}
     */
    public static createInstance<T extends AbstractHttpService>(c: new () => T): T {
        return new c();
    }
}
